import React, {useState, useEffect} from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import ApiSoftland from '@app/services/apis.softland.service';

const Styles = styled.div``;

const SelectCanales = ({id, value, onChange, isInvalid, isClearable}) => {
    const [items, setItems] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState();

    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };

    useEffect(() => {
        ApiSoftland.getContratistas().then((response) => {
            setItems(response);
        });
    }, []);

    useEffect(() => {
        const newOptions = items.map((item) => {
            return {
                value: item.cod_contratista,
                label: item.nombre
            };
        });
        setOptions(newOptions);
        if (typeof value === 'string' || typeof value === 'number') {
            setSelectedValue(
                newOptions.find((opt) => opt.value === value)
            );
        } else if(Array.isArray(value)){
            setSelectedValue(value.map(va=>({label:va.nombre,value:va.cod_contratista})));
        }
    }, [items,value]);
    
    return (
        <Styles>
            <Select
                inputId={id}
                className={`react-select-container ${
                    isInvalid ? 'is-invalid' : ''
                }`}
                styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
                menuPortalTarget={document.body}
                classNamePrefix="react-select"
                placeholder="Seleccione..."
                options={options}
                value={selectedValue}
                onChange={onSelectValue}
                isClearable={isClearable}
            />
        </Styles>
    );
};

SelectCanales.defaultProps = {
    isClearable: false
};

export default SelectCanales;
